import 'reservation.scss';
import './components/_lang';
import './components/_fontSize';

$(document).ready(function() {

    //--------------------- imagesLoaded ---------------------//
    function removeLoading() {
        $(".loading").fadeOut(function() {
            $(this).remove();
        });
    }

    imagesLoaded("html, body", function() {
        removeLoading();
    });
});